import * as XLSX from 'xlsx';
export const isEqual = (arr1: string[], arr2: string[]): boolean => {
	if (arr1.length !== arr2.length) return false;
	if (arr1.length !== arr2.length) return false;

	for (const item of arr1) {
		if (!arr2.includes(item)) {
			return false;
		}
	}
	for (const item of arr1) {
		if (!arr2.includes(item)) {
			return false;
		}
	}

	return true;
};

export const exportExcelFromArray = (headers, values, fileName) => {
	const columnWidth: { wch: number }[] = headers.map(x => ({ wch: x.width ?? x.title.length }));
	const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(values);
	/* generate workbook and add the worksheet */
	ws['!cols'] = columnWidth;
	XLSX.utils.sheet_add_aoa(ws, [headers.map(a => a.title)], { origin: 'A1' });
	const wb: XLSX.WorkBook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
	/* save to file */
	XLSX.writeFile(wb, `${fileName}.xlsx`);
};
